import { BlockStoreStats } from '#block-store/types';
import { CallStats, getPrintIndentation } from '#common/stats';
export class LogStoreStats extends BlockStoreStats {
    static STATS_NAME = 'LogStoreStats';
    totalBytesRead = 0;
    totalBytesWritten = 0;
    readLayout;
    fetchedObjects;
    putObject;
    constructor(log) {
        super(LogStoreStats.STATS_NAME, log);
        this.readLayout = new CallStats('readLayout', log);
        this.fetchedObjects = new CallStats('fetchedObjects', log);
        this.putObject = new CallStats('putObject', log);
    }
    toString(indentLevel) {
        const newLineWithIndentation = '\n' + getPrintIndentation(indentLevel);
        let result = super.toString(indentLevel);
        result += newLineWithIndentation;
        result += `totalBytesRead=${this.totalBytesRead.toFixed()}`;
        result += newLineWithIndentation;
        result += `totalBytesWritten=${this.totalBytesWritten.toFixed()}`;
        return result;
    }
}
